"use-strict";
/* global $ */



import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/respimg/ls.respimg';
window.$ = window.jQuery = require('jquery');
import Barba from 'barba.js';
import Isotope from 'isotope-layout';
var imagesLoaded = require('imagesloaded');
imagesLoaded.makeJQueryPlugin($);
require("select2-full");
import moment from 'moment';
require("daterangepicker");
import Swiper from 'swiper/dist/js/swiper.min.js';
var fx = require('money');
var accounting = require('accounting');
import fullpage from 'fullpage.js';
import ScrollMagic from 'ScrollMagic';
// import 'animation.gsap';
import 'debug.addIndicators';
// import SmoothScroll from 'smoothscroll-for-websites';
// import noUiSlider from 'nouislider';
require('waypoints/lib/noframework.waypoints.min');
require('malihu-custom-scrollbar-plugin-concat');
// import hoverintent from 'hoverintent';
import localForage from "localforage";
import 'parsleyjs';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
import anime from 'animejs';
import Warp from 'warpjs';
// import ScrollSnap from 'scroll-snap'

var Common = {
    lastScrollPos: 0,
    $container: null,
    sound: false,
    iso: null,
    lastUpdateTime: null,
    bgmEnabled: false,
    init: function(){
        // Common.iso = $('html').data('iso');
        // init methods
        Common.detectDevice();
        Common.initBarba();
        // Common.lastUpdateTime = Common.getContentAjax('https://salescms2.sino.com/pages/LastUpdateTime?projectID=120&lang='+Common.iso);
        
        // events that register once
        $(document).on('click', ".ps-image", Common.imagesZoom);

        $(document).on('click', '#landing-disclaimer .close', function(){
            if(!$('html').hasClass('agreed-disclaimer')){
                anime({
                    targets: $("#landing-disclaimer")[0],
                    opacity: 0,
                    duration: 500,
                    easing: 'easeOutCubic',
                    begin: function(){
                        $('html').addClass('agreed-disclaimer');
                        $(window).trigger('resize');
                    },
                    complete: function(){
                        
                        if(!Common.isMobile()) Common.enableBgm();
                    }
                });
                $(document).trigger('agreeddisclaimer');
            }else{
                $("#landing-disclaimer").css({
                    display: 'none',
                    opacity: 0
                });
            }
            
        });
        $(document).on('click', '.popup-open', function(e){
            var $content = $(e.currentTarget).siblings('.scrollable-popup-content');
            var popup = new ScrollablePopup();
            popup.open($content);
        });

        $(document).on('click', '.toggle-sound', function(){
            Common.toggleBgm();
        });

        $(document).on('click', '.open-landing-disclaimer', function(){
            $("#landing-disclaimer").css({
                display: 'block',
                opacity: 1
            });
        });

        $("#back-top").on("click", function(){
            if(!Common.isIE()){
                const scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement || $('html, body')[0];
                anime({
                    targets: scrollElement,
                    scrollTop: 0,
                    duration: 500,
                    easing: 'easeOutQuad'
                });
            }else{
                $('html, body').animate({
                    scrollTop: 0
                }, 800);
            }
            
        });

        $(document).on('lazyloaded', function(e){
            Waypoint.refreshAll();
        });
        
        $(window).scroll(function(e){
            var window_scrolltop = $(window).scrollTop();
            if(window_scrolltop > 100){
                $('#back-top').addClass('show');
            }else{
                $('#back-top').removeClass('show');
            }
        });

        $(document).on('click', 'sup button', function(){
            const scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement;
            const winHeight = window.innerHeight|| document.documentElement.clientHeight|| 
            document.body.clientHeight;

            anime({
                targets: scrollElement,
                scrollTop: Common.$container.find('.section.index').offset().top,
                duration: 500,
                easing: 'easeOutQuad'
            });
        });

        $(document).on('click', '.email', function(){
            gtag('event', 'click', {
              'event_category' : 'engagment',
              'event_label' : 'Email Click'
            });
        });

        $(document).on('click', '.phone', function(){
            gtag('event', 'click', {
              'event_category' : 'engagment',
              'event_label' : 'Phone Click'
            });
        });

        $(document).on('click', '#header nav button', function(){
            $(this).addClass('active');
            Common.$container.find('.gallery-nav').css({
                'margin-top': 0
            });
        });

        $(document).on('click', '#header nav button.active', function(){
            $(this).removeClass('active');
            Common.$container.find('.gallery-nav').css({
                'margin-top': -33
            });
        });

        $(document).on('click', '.side-menu ul .expand', function(){
            $(this).parent().siblings().find('.expand').removeClass('active');
            $(this).toggleClass('active');
        });

        $(document).on('click', '.side-menu .popup-open', function(){
            if(!$(this).closest('.sub-nav').length){
                $(this).parent('li').siblings().find('.expand').removeClass('active');
            }
        });

        
    },
    initBarba: function(){
        Barba.Pjax.Dom.containerClass = "transition-container";
        Barba.Pjax.Dom.wrapperId = "transition-wrapper";
        Barba.Pjax.Dom.dataNamespace = "template";
        Barba.Utils.xhrTimeout = 10000;
        Barba.Pjax.cacheEnabled = false;
        Barba.Dispatcher.on('newPageReady', function(current, prev, container) {
            gtag('config', 'UA-77776744-2', {
              'page_path': window.location.pathname
            });
            Common.$container = $(container);
            Common.splitText();
            Common.initBgm();
            // common code run on every page
            
            Common.$container.find("#footer .expand").on('click', Common.toggleExpandFooter);

            Common.$container.find('.mobile-menu-bar .toggle-nav').on('click', Common.toggleMobileMenu);

            Common.slideMemory = [];
            Common.$container.find('.section.slider.gallery.double').each(function(){
                var $this = $(this);
                var $slider = $this.find('.swiper-container');
                var view = $this.hasClass('half') ? 1.25 : 1.25;

                
                Common.slideMemory['desktop'] = $this.find('.swiper-slide.desktop');
                Common.slideMemory['mobile'] = $this.find('.swiper-slide.mobile');
                if(window.matchMedia('(max-width: 767px)').matches){
                    $this.find('.swiper-slide.desktop').remove();
                }else{
                    $this.find('.swiper-slide.mobile').remove();
                }
                

                new Swiper ($slider[0], {
                    slidesPerView: view,
                    loop: true,
                    loopAdditionalSlides: 1,
                    loopedSlides: 1,
                    centeredSlides: true,
                    // centeredSlides: true,
                    navigation: {
                        nextEl: $this.find('.swiper-button-next'),
                        prevEl: $this.find('.swiper-button-prev'),
                    },
                    // breakpoints: {
                    //     896: {
                    //         slidesPerView: 1.2
                    //     }
                    // },
                    on: {
                        init: function(){
                            this.update();
                            var that = this;
                            if(window.matchMedia('(max-width: 767px)').matches){
                                this.device = 'mobile';
                            }else{
                                this.device = 'desktop';
                            }

                            $(document).on('lazyloaded', function(e){
                                if($(e.target).closest('.swiper-container').length){
                                    that.loopCreate();
                                }
                                that.update();
                            });
                        },
                        resize: function(){
                            if(window.matchMedia('(max-width: 767px)').matches && this.device == 'desktop'){
                                this.device = 'mobile';
                                if(Common.slideMemory['mobile']){
                                    $this.find('.swiper-wrapper').append(Common.slideMemory['mobile']);
                                    Common.slideMemory['mobile'] = null;
                                    
                                    Common.slideMemory['desktop'] = $this.find('.swiper-slide.desktop');
                                    $this.find('.swiper-slide.desktop').remove();
                                }
                            }else if(window.matchMedia('(min-width: 768px)').matches && this.device == 'mobile'){
                                this.device = 'desktop';
                                if(Common.slideMemory['desktop']){
                                    $this.find('.swiper-wrapper').append(Common.slideMemory['desktop']);
                                    Common.slideMemory['desktop'] = null;

                                    Common.slideMemory['mobile'] = $this.find('.swiper-slide.mobile');
                                    $this.find('.swiper-slide.mobile').remove();
                                }
                            }

                            this.update();
                        }
                    }
                });
            });

            $(window).on('resize orientationchange', function(){
                var headerMainHeight = Common.$container.find('.header-main').height();
                var headerSubHeight = window.matchMedia('(max-width: 1023px)').matches ? 0 :Common.$container.find('.home-nav nav').height();
                var mobileMenuHeight = Common.$container.find('.mobile-menu-bar').is(':visible') ? Common.$container.find('.mobile-menu-bar').outerHeight() : 0;
                var footerHeight = Common.$container.find('#footer').css('display') !== 'none' ? Common.$container.find('#footer .stick').height() : 0;
                var windowHeight = $(window).height();
                var headerHeight = Common.$container.find('#header').height();
                var mainHeight = windowHeight - headerMainHeight - headerSubHeight - mobileMenuHeight;
                var barHeight = $(window).outerHeight() - headerHeight;

                if(window.matchMedia('(max-width: 1023px)').matches){
                    barHeight = $(window).outerHeight() - headerHeight
                }

                // var disclaimerHeight = $(window).outerHeight() - footerHeight;
                // Common.$container.find('#main').height(mainHeight);
                // Common.$container.find('#landing-disclaimer').height(disclaimerHeight);
                Common.$container.find('.side-menu').css({
                    height: barHeight,
                    top: headerHeight
                });
                Common.$container.find('.side-menu .container').css({height: '100%'});

                if($('html').hasClass('mobile-menu-open')){
                    Common.$container.find('.home-nav>nav').css({
                        height: $(window).outerHeight() - headerMainHeight - mobileMenuHeight,
                    });
                }
                
                Common.$container.find('.section.kv').css({height: mainHeight});

                Common.$container.find('.image-note').each(function(){
                    var buttonHeight = $(this).find('.note-toggle').outerHeight();
                    $(this).height(buttonHeight);
                });
            }).trigger('resize');

            Common.$container.find("button.hamburger.menu").on('click', function(){
                $('html').removeClass('menu-close');

                var headerHeight = Common.$container.find('#header').height();
                var barHeight = $(window).outerHeight() - headerHeight;
                Common.$container.find('.side-menu').css({
                    height: barHeight,
                    top: headerHeight
                });
                $('html').toggleClass('menu-open');
            });

            // close side menu
            $(document).on('click', function(e){
                var container = Common.$container.find('.side-menu');
                var $expander = Common.$container.find('#header .hamburger');
                var $exclude = $('.scrollable-popup');
                var clickedOnExcluded = $exclude.is(e.target) || $exclude.has(e.target).length !== 0;
                if (!container.is(e.target) && container.has(e.target).length === 0 && $('html').hasClass('menu-open') && !$expander.is(e.target) && $expander.has(e.target).length === 0 && !clickedOnExcluded){
                    $('html').removeClass('menu-open');
                }
            });

            // close expanded footer
            $(document).on('click', function(e){
                var container = Common.$container.find('#footer');
                var $expander = Common.$container.find('#footer .expand');
                var $exclude = $('.scrollable-popup');
                var clickedOnExcluded = $exclude.is(e.target) || $exclude.has(e.target).length !== 0;
                if (!container.is(e.target) && container.has(e.target).length === 0 && $expander.hasClass('open') && !$expander.is(e.target) && $expander.has(e.target).length === 0 && !clickedOnExcluded){
                    Common.closeExpandFooter();
                }
            });

            Common.$container.find('.note-toggle').on('click', function(){
                var $note = $(this).closest('.image-note');
                var buttonHeight = $note.find('.note-toggle').outerHeight();
                
                $note.toggleClass('active');
                if($note.hasClass('active')){
                    var totalHeight = $note.find('.note-detail').outerHeight() + buttonHeight;
                    var parentHeight = $note.parent().height();
                    if(parentHeight > totalHeight){
                        $note.height(totalHeight);
                    }else{
                        $note.height(parentHeight);
                        setTimeout(function(){
                            $note.css({
                                "overflow-y": "auto"
                            });
                        }, 300);
                    }
                    
                }else{
                    $note.css({
                        "overflow-y": "hidden"
                    });
                    $note.height(buttonHeight);
                }
            });

            

            // $(document).on('mouseleave', '#header nav button, .gallery-nav', function(){
            //     Common.$container.find('.gallery-nav').css({
            //         'margin-top': -33
            //     });
            // });

            // content scroll
            // var swiper = new Swiper('.swiper-container', {
            //     direction: 'vertical',
            //     slidesPerView: 1,
            //     mousewheel: true,
            //     touchRatio: 0,
            //     scrollbar: {
            //         el: '.swiper-scrollbar',
            //     },
            // });
        });
        Barba.Pjax.getTransition = function() {
            // animation controller
            // reference: https://github.com/barbajs/barba/issues/19#issuecomment-223874845
            return Common.pageTransition;
        };
    },
    pageTransition: Barba.BaseTransition.extend({
        start: function() {
            Promise
                .all([this.newContainerLoading, this.fadeOut()])
                .then(this.fadeIn.bind(this));
        },
        fadeOut: function() {
            var deferred = Barba.Utils.deferred();

            $("html").removeClass("landing");

            $("#transition-animation").css({
                display: 'block'
            });
            anime({
                targets: $("#transition-animation")[0],
                opacity: 1,
                easing: 'easeOutCubic',
                duration: 300,
                complete: function(){
                    deferred.resolve();
                    $('html').addClass('menu-close');
                }
            });
            return deferred.promise;
        },
        fadeIn: function() {
            window.scrollTo(0, 0);
            $('html').removeClass('menu-open');
            $('html').removeClass('mobile-menu-open');
            $('html').addClass('mobile-menu-close');
            var _this = this;

            _this.done();
        }
    }),
    pageTransitionLeave: function(){

    },
    pageTransitionEnter: function(){
        return new Promise(function(resolve){
                $("#transition-animation .layer-1").show();
                $("#transition-animation .opening").hide();
                Common.$container.show();
                resolve();
                anime({
                    targets: $("#transition-animation")[0],
                    opacity: 0,
                    easing: 'easeOutCubic',
                    duration: 300,
                    complete: function(){
                        $("#transition-animation").hide();
                    }
                });
            // }
        });
    },
    toggleMobileMenu: function(){
        if(!$('html').hasClass('mobile-menu-open')){
            var headerHeight = Common.$container.find('#header').height();
            // var footerHeight = Common.$container.find('#footer .stick').height();
            var windowHeight = $(window).height();
            var menuHeight = windowHeight - headerHeight;
            Common.$container.find('.home-nav>nav').height(menuHeight);
        }else{
            Common.$container.find('.home-nav>nav').css({
                height: ''
            });
        }
        $('html').removeClass('mobile-menu-close');
        $('html').toggleClass('mobile-menu-open');
    },
    toggleExpandFooter: function(){
        var $drawer = Common.$container.find('#footer .drawer');
        var $expander = Common.$container.find('#footer .expand');
        var height = Common.$container.find('#footer .drawer>.container>.wrapper>.padder').outerHeight();
        if($expander.hasClass('open')){
            height = 0;
            $expander.removeClass('open');
        }else{
            $expander.addClass('open');
        }
        var action = anime({
            targets: $drawer[0],
            height: height,
            easing: 'easeOutCubic',
            duration: 500
        });
    },
    closeExpandFooter: function(){
        var $drawer = Common.$container.find('#footer .drawer');
        var $expander = Common.$container.find('#footer .expand');
        $expander.removeClass('open');
        anime({
            targets: $drawer[0],
            height: 0,
            easing: 'easeOutCubic',
            duration: 500
        });
    },
    splitText: function(){
        Common.$container.find(".split").each(function(){
            var charCount = $(this).text().length;
            var i = 0;
            $(this).html($(this).text().replace(/(\S|\s)/g, function(c){
                var style = '';
                var markup = '';
                if(c !== ' ' ||  !window.matchMedia('(max-width: 896px) and (orientation: portrait)').matches){
                    markup = "<span class='letter' style='animation-delay: "+ i +"s;'>"+c+"</span>";
                }else{
                    markup = "<br class='mobile-only'>";
                }
                
                i = i + 0.1;
                return markup;
            }));
        });
    },
    isMobile: function(){
        if(!('ontouchstart' in window)){
            return false;
        }
        return true;
    },
    isIE: function(){
        return !!window.document.documentMode;
    },
    throttle: function(a,b){var c,d;return function(){var e=this,f=arguments,g=+new Date;c&&g<c+a?(clearTimeout(d),d=setTimeout(function(){c=g,b.apply(e,f)},a)):(c=g,b.apply(e,f))}},
    detectDevice: function(){
        // $(window).on('mouseover', function onFirstHover() {
        //     $('html').addClass('desktop').removeClass('mobile');
        //     $(window).off('mouseover', onFirstHover, false);
        // });
        if(!('ontouchstart' in window)){
            $('html').addClass('desktop').removeClass('mobile');
        }
    },
    video2Cover: function($container, alignment){
        var $videos = $container.find('video.cover-video');
        $videos.each(function(){
            var $this = $(this);
            var parentWidth = $this.parent().outerWidth();
            var parentHeight = $this.parent().outerHeight();
            var aspectRatio = $this.data('ratio');
            var newHeight, newWidth, halfWidth, halfHeight;
            if(alignment === 'bottom'){
                if(parentWidth / parentHeight > aspectRatio){
                    if(newWidth > parentWidth){
                        newWidth = parentHeight*aspectRatio;
                        newHeight = newWidth/aspectRatio;
                        halfWidth = newWidth/2;
                        $this.css({
                            "height": newHeight,
                            "width":newWidth,
                            "left":"50%",
                            "bottom":"auto",
                            "top":"auto",
                            "transform": "translate(-"+halfWidth+"px, 0)"
                        });
                    }else{
                        newHeight = parentWidth/aspectRatio;
                        newWidth = newHeight*aspectRatio;
                        halfHeight = newHeight/2;
                        $this.css({
                            "height":newHeight,
                            "width": newWidth,
                            "left": 0,
                            "bottom":0,
                            "top":"auto",
                            "transform": ""
                        });
                    }
                }else{
                    newHeight = parentHeight;
                    newWidth = newHeight*aspectRatio;
                    halfWidth = newWidth/2;
                    $this.css({
                        "height":newHeight,
                        "width":newWidth,
                        "left":"50%",
                        "bottom": 0,
                        "top":"auto",
                        "transform": "translate(-"+halfWidth+"px, 0)"
                    });
                }
            }else{
                if(parentWidth / parentHeight > aspectRatio){
                    if(newWidth > parentWidth){
                        newWidth = parentHeight*aspectRatio;
                        newHeight = newWidth/aspectRatio;
                        halfWidth = newWidth/2;
                        $this.css({
                            "height": newHeight,
                            "width":newWidth,
                            "left":"50%",
                            "top":"auto",
                            "transform": "translate(-"+halfWidth+"px, 0)"
                        });
                    }else{
                        newHeight = parentWidth/aspectRatio;
                        newWidth = newHeight*aspectRatio;
                        halfHeight = newHeight/2;
                        $this.css({
                            "height":newHeight,
                            "width": newWidth,
                            "left": 0,
                            "top":"50%",
                            "transform": "translate(0, -"+halfHeight+"px)"
                        });
                    }
                }else{
                    newHeight = parentHeight;
                    newWidth = newHeight*aspectRatio;
                    halfWidth = newWidth/2;
                    $this.css({
                        "height":newHeight,
                        "width":newWidth,
                        "left":"50%",
                        "top": 0,
                        "transform": "translateX(-"+halfWidth+"px)"
                    });
                }
            }
            
                
        });
    },
    imagesZoom: function(e){
        e.preventDefault();
        var $this = $(e.currentTarget);
        var $wrapper = $this.closest('.section');
        var $image = $wrapper.find('.ps-image');
        var index = $wrapper.find('.ps-image').index($this);
        var items = [];
        $image.each(function(){
            let src = $(this).attr("src");
            items.push({
                src: src,
                w: $(this)[0].naturalWidth,
                h: $(this)[0].naturalHeight,
                msrc: src,
            });
        });
        var $pswp = $('.pswp')[0];
        var options = {
                index: index,
                bgOpacity: 0.8,
                // showHideOpacity: true,
                // showAnimationDuration: 2000,
                history: false,
                // fullscreenEl: true,
                shareEl: false,
                counterEl: false,
                // closeOnScroll: false,
                scaleMode: 'fit',
                getThumbBoundsFn: function(i) {
                    var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
                    var rect = $image[i].getBoundingClientRect();
                    return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
                }
        }
        var ps = new PhotoSwipe($pswp, PhotoSwipeUI_Default, items, options);
        ps.init();
    },
    initBgm: function(){
        if(Common.sound){
            Common.$container.find('.toggle-sound').addClass('active');
        }
    },
    enableBgm: function(){
        Common.$container.find('.toggle-sound').addClass('active');
        document.getElementById('bgm').play();
        Common.sound = true;
    },
    disableBgm: function(){
        Common.$container.find('.toggle-sound').removeClass('active');
        document.getElementById('bgm').pause();
        Common.sound = false;
    },
    toggleBgm: function(){
        if(Common.$container.find('.toggle-sound').hasClass('active')){
            Common.disableBgm();
            Common.bgmEnabled = false;
        }else{
            Common.enableBgm();
            Common.bgmEnabled = true;
        }
    },
    loadScript: function (src) {
        return new Promise(function (resolve, reject) { 
            if($('script[src="'+ src +'"]').length > 0){
                resolve();
            }else{
                var s;
                s = document.createElement('script');
                s.src = src;
                s.onload = resolve;
                s.onerror = reject;
                document.head.appendChild(s);
            }
        });
    },
    // getContentAjax: function(url){console.log(url);
    //     return new Promise(function(resolve){
    //         $.ajax({
    //             url: url,
    //             method: 'get',
    //             crossDomain: true,
    //             success: function(response){console.log(response);
    //                 resolve(response);
    //             }
    //         });
    //     });
        
    // }
}

var Home = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'home',
        onEnter: function() {
            Home.$container = $(this.container);

            // Home.$container.find('.kv-video')[0].play();
            if($('html').hasClass('agreed-disclaimer')){
                if(Home.$container.find('.kv-video').length) Home.$container.find('.kv-video')[0].play();
                if(Home.$container.find('#youtube-video').length) Home.initYoutube();
            }else{
                $(document).on('agreeddisclaimer', function(){
                    if(Home.$container.find('.kv-video').length) Home.$container.find('.kv-video')[0].play();
                    if(Home.$container.find('#youtube-video').length) Home.initYoutube();
                })
            }

            var slider = new Swiper (Home.$container.find('.swiper-container')[0], {
                slidesPerView: 1,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                  },
                pagination: {
                      el: Home.$container.find('.swiper-pagination')[0],
                      clickable: true
                },
                navigation: {
                    nextEl: Home.$container.find('.swiper-button-next')[0],
                    prevEl: Home.$container.find('.swiper-button-prev')[0],
                },
                on: {
                    slideChangeTransitionEnd: function(){
                        var newIndex = slider.activeIndex;
                        var oldIndex = slider.previousIndex;

                        if($(slider.slides[oldIndex]).find('video').length) $(slider.slides[oldIndex]).find('video')[0].pause();
                        if($(slider.slides[newIndex]).find('video').length) $(slider.slides[newIndex]).find('video')[0].play();
                        if(!$(slider.slides[newIndex]).find('#youtube-video').length){
                            YoutubeIframePlayer.player.seekTo(0);
                            YoutubeIframePlayer.player.stopVideo();
                        }
                        if($(slider.slides[newIndex]).find('#youtube-video').length) YoutubeIframePlayer.player.playVideo();
                    },
                    init: function(){
                        $(window).trigger('resize');
                        Common.video2Cover(Home.$container, 'bottom');
                        
                        // $(window).trigger('resize');
                    },
                    resize: function(){
                        var swiper = this;
                        $(swiper.slides).each(function(){
                            $(this).width($(this).closest('.swiper-wrapper').width());
                        });
                    }
                }
            });

            // event
            $(window).on('resize orientationchange', function(){
                
                $(window).one('resize', function(){
                    Common.video2Cover(Home.$container, 'bottom');
                });
            });

            setTimeout(() => {
                window.dispatchEvent(new Event("resize"))
            }, 200);

        },
        onEnterCompleted: function() {
            Common.pageTransitionEnter().then(function(){
                $(window).trigger('resize');
                Common.video2Cover(Home.$container, 'bottom');
            });
            
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {

        }
    }),
    initYoutube:function(){
        YoutubeIframePlayer.container = Home.$container.find('#youtube-video')[0];
        YoutubeIframePlayer.videoId = Home.$container.find('#youtube-video').data('id');
        YoutubeIframePlayer.init();
    },
    resize: function(){
        Home.windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        Home.headerHeight = $('#header').outerHeight(true);
        
        Home.$container.find('.new-york .parallax-wrapper').css({
            top: -Home.windowHeight
        });
        if($(window).width() !== Home.cachedWidth || window.matchMedia('(min-width: 1025px)').matches){
            Home.cachedWidth = $(window).width();
            // Home.setKVHeight();
        }
    }
}

var Kadoorie = {
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'kadoorie-hill',
        onEnter: function() {
            Kadoorie.$container = $(this.container);
            
            ///////////////// init layout ///////////////
            

            ///////////////// events ////////////////////
            // Contact.$container.find('.contact-form').on('submit', Contact.submitForm);
            // new Snap( Kadoorie.$container.find('.main-wrapper')[0], 'section', {
            //     offsetTop: 70,
            //     disableBelow: 1024
            // });
            Common.video2Cover(Kadoorie.$container);
            $(window).on('resize orientationchange', function(){
                $(window).one('resize', function(){
                    Common.video2Cover(Kadoorie.$container);
                });
            });

        },
        onEnterCompleted: function() {
            Common.pageTransitionEnter().then(function(){
                Kadoorie.$container.find('.section.kv video')[0].play();

                Kadoorie.$container.find('.section').each(function(){
                    var $this = $(this);
                    var wp = new Waypoint({
                        element: this,
                        handler: (d) => {
                            $this.addClass('entered');
                            wp.destroy();
                        },
                        offset: window.matchMedia('(max-width: 767px)').matches ? '90%' : '60%'
                    });
                });
            });


        },
        onLeave: function() {

        },
        onLeaveCompleted: function() {
            
        }
    }),
}

var Vision = {
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'vision',
        onEnter: function() {
            Vision.$container = $(this.container);
            
            ///////////////// init layout ///////////////
            new Swiper (Vision.$container.find('.slider.auto .swiper-container')[0], {
                slidesPerView: 1,
                effect: 'fade',
                speed: 1000,
                fadeEffect: {
                    crossFade: true
                },
                autoplay: true,
                on: {
                    // init: function(){
                    //     var that = this;
                    //     $(document).on('lazyloaded', function(e){
                    //         if($(e.target).closest('.swiper-container').length){
                    //             that.loopDestroy();
                    //             that.loopCreate();
                    //         }
                    //     });
                    // }
                }
            });

            ///////////////// events ////////////////////
            // Contact.$container.find('.contact-form').on('submit', Contact.submitForm);
            Common.video2Cover(Vision.$container);
            $(window).on('resize orientationchange', function(){
                Common.video2Cover(Vision.$container);
                // $(window).one('resize', function(){
                //     Common.video2Cover(Vision.$container);
                // });

                var headerMainHeight = Common.$container.find('.header-main').height();
                var headerSubHeight = window.matchMedia('(max-width: 1023px)').matches ? 0 :Common.$container.find('.home-nav nav').height();
                var mobileMenuHeight = Common.$container.find('.mobile-menu-bar').is(':visible') ? Common.$container.find('.mobile-menu-bar').outerHeight() : 0;
                var windowHeight = $(window).height();
                var mainHeight = windowHeight - headerMainHeight - headerSubHeight - mobileMenuHeight;

                Vision.$container.find('.section.gallery .wrapper').height(mainHeight);

            }).trigger('resize');


        },
        onEnterCompleted: function() {
            Common.pageTransitionEnter().then(function(){

                Vision.$container.find('.section').each(function(){
                    var $this = $(this);
                    var wp = new Waypoint({
                        element: this,
                        handler: (d) => {
                            $this.addClass('entered');
                            // wp.destroy();
                        },
                        offset: window.matchMedia('(max-width: 767px)').matches ? '90%' : '60%'
                    });
                });
            });
        },
        onLeave: function() {

        },
        onLeaveCompleted: function() {
            
        }
    })
}

var Architecture = {
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'architecture',
        onEnter: function() {
            Architecture.$container = $(this.container);
            
            ///////////////// init layout ///////////////

            ///////////////// events ////////////////////
            // Contact.$container.find('.contact-form').on('submit', Contact.submitForm);


        },
        onEnterCompleted: function() {
            
            // Architecture.kvPosition();
            // $(window).on('resize orientationchange', function(){
            //     Architecture.kv2Top();
            // });

            
            Common.pageTransitionEnter().then(function(){
                Architecture.$container.find('.section.kv .bkgimg img').css({
                    'transform': 'scale(1)'
                });

                Architecture.$container.find('.section').each(function(){
                    var $this = $(this);
                    var wp = new Waypoint({
                        element: this,
                        handler: (d) => {
                            $this.addClass('entered');
                            wp.destroy();
                        },
                        offset: window.matchMedia('(max-width: 767px)').matches ? '90%' : '60%'
                    });
                });
            });
        },
        onLeave: function() {

        },
        onLeaveCompleted: function() {
            
        }
    }),
    kvPosition: function(){
        var kv = Architecture.$container.find('.section.kv .bkgimg img');
        var kvImage = new Image();
        kvImage.onload = function(){
            
            var windowWidth = Architecture.$container.find('.section.kv .bkgimg').width();
            var ratio = this.width / windowWidth;
            var trueHeight = this.height / ratio;
            Common.pageTransitionEnter().then(function(){
                kv.css({
                    bottom: -trueHeight + Architecture.$container.find('.section.kv .bkgimg').height() + 37
                });

                Architecture.$container.find('.section').each(function(){
                    var $this = $(this);
                    var wp = new Waypoint({
                        element: this,
                        handler: (d) => {
                            $this.addClass('entered');
                            // wp.destroy();
                        },
                        offset: window.matchMedia('(max-width: 767px)').matches ? '95%' : '60%'
                    });
                });
            });
        }
        kvImage.src = kv.attr('src');
    },
    kv2Top: function(){
        var kv = Architecture.$container.find('.section.kv .bkgimg img');
        kv.css({
            bottom: 'auto',
            top: 0
        });
    }
}

var Residences = {
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'residences',
        onEnter: function() {
            Residences.$container = $(this.container);
            
            ///////////////// init layout ///////////////

            ///////////////// events ////////////////////
            // Contact.$container.find('.contact-form').on('submit', Contact.submitForm);
            Common.video2Cover(Residences.$container);
            $(window).on('resize orientationchange', function(){
                $(window).one('resize', function(){
                    Common.video2Cover(Residences.$container);
                });
            });

        },
        onEnterCompleted: function() {
            Common.pageTransitionEnter().then(function(){
                Residences.$container.find('.section').each(function(){
                    var $this = $(this);
                    var wp = new Waypoint({
                        element: this,
                        handler: (d) => {
                            $this.addClass('entered');
                            // wp.destroy();
                        },
                        offset: window.matchMedia('(max-width: 767px)').matches ? '90%' : '60%'
                    });
                });
            });
        },
        onLeave: function() {

        },
        onLeaveCompleted: function() {
            
        }
    })
}

var View = {
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'view',
        onEnter: function() {
            View.$container = $(this.container);
            
            ///////////////// init layout ///////////////
            var slider = new Swiper (View.$container.find('.swiper-container')[0], {
                slidesPerView: 1,
                effect: 'fade',
                allowTouchMove: false,
                fadeEffect: {
                    crossFade: true
                },
                on: {
                    slideChangeTransitionEnd: function(){
                        var newIndex = slider.activeIndex;
                        var oldIndex = slider.previousIndex;

                        if($(slider.slides[oldIndex]).find('video').length) $(slider.slides[oldIndex]).find('video')[0].pause();
                        if($(slider.slides[newIndex]).find('video').length) $(slider.slides[newIndex]).find('video')[0].play();
                    },
                    init: function(){
                        View.$container.find('.controls select').on('change', function(e){
                            var level = View.$container.find('.controls select[name=level]').val();
                            var direction = View.$container.find('.controls select[name=direction]').val();
                            var index = {
                                high: {
                                    north: 0,
                                    south: 3,
                                },
                                mid: {
                                    north: 1,
                                    south: 4,
                                },
                                low: {
                                    north: 2,
                                    south: 5,
                                },
                            };
                            slider.slideTo(index[level][direction]);
                        });

                        var swiper = this;
                        setTimeout(function(){
                            $(window).trigger('resize');
                            swiper.update();
                        }, 200);
                        
                        $(document).on('lazyloaded', function(e){
                            swiper.update();
                        });
                    }
                }
            });

            setTimeout(function(){
                $(window).trigger('resize');
                slider.update();
            }, 200);

            ///////////////// events ////////////////////
            // Contact.$container.find('.contact-form').on('submit', Contact.submitForm);
            View.$container.find('.section.kv .bkgimg img').css({
                'transform': 'scale(1)'
            });

            
        },
        onEnterCompleted: function() {
            Common.pageTransitionEnter().then(function(){
                View.$container.find('.section').each(function(){
                    var $this = $(this);
                    var wp = new Waypoint({
                        element: this,
                        handler: (d) => {
                            $this.addClass('entered');
                            // wp.destroy();
                        },
                        offset: window.matchMedia('(max-width: 767px)').matches ? '90%' : '60%'
                    });
                });

                View.$container.find('video#first')[0].play();

                $(window).trigger('resize');
            });
        },
        onLeave: function() {

        },
        onLeaveCompleted: function() {
            
        }
    })
}

var Clubhouse = {
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'clubhouse',
        onEnter: function() {
            Clubhouse.$container = $(this.container);
            
            ///////////////// init layout ///////////////
            
            ///////////////// events ////////////////////
            // Contact.$container.find('.contact-form').on('submit', Contact.submitForm);
            Clubhouse.$container.find('.section.kv .bkgimg img').css({
                'transform': 'scale(1)'
            });

        },
        onEnterCompleted: function() {
            Common.pageTransitionEnter().then(function(){
                Clubhouse.$container.find('.section').each(function(){
                    var $this = $(this);
                    var wp = new Waypoint({
                        element: this,
                        handler: (d) => {
                            $this.addClass('entered');
                            // wp.destroy();
                        },
                        offset: window.matchMedia('(max-width: 767px)').matches ? '95%' : '60%'
                    });
                });
            });
        },
        onLeave: function() {

        },
        onLeaveCompleted: function() {
            
        }
    })
}

var Neighborhood = {
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'neighborhood',
        onEnter: function() {
            Neighborhood.$container = $(this.container);
            
            ///////////////// init layout ///////////////

            ///////////////// events ////////////////////
            // Contact.$container.find('.contact-form').on('submit', Contact.submitForm);

        },
        onEnterCompleted: function() {
            $(window).on('resize orientationchange', function(){
                $(window).one('resize', function(){
                    Common.video2Cover(Neighborhood.$container, 'bottom');
                });
            });

            Common.video2Cover(Neighborhood.$container, 'bottom');

            Common.pageTransitionEnter().then(function(){
                Neighborhood.$container.find('.section.map').each(function(){
                    var $this = $(this);
                    var wp = new Waypoint({
                        element: this,
                        handler: (d) => {
                            $this.find('.pointer').addClass('show');
                            wp.destroy();
                        },
                        offset: window.matchMedia('(max-width: 767px)').matches ? '90%' : '60%'
                    });
                });

                Neighborhood.$container.find('.section').each(function(){
                    var $this = $(this);
                    var wp = new Waypoint({
                        element: this,
                        handler: (d) => {
                            $this.addClass('entered');
                            // wp.destroy();
                        },
                        offset: window.matchMedia('(max-width: 767px)').matches ? '90%' : '60%'
                    });
                });

                new Swiper (Neighborhood.$container.find('.section.gallery .swiper-container')[0], {
                    slidesPerView: 1.25,
                    loop: true,
                    loopAdditionalSlides: 1,
                    loopedSlides: 1,
                    centeredSlides: true,
                    // centeredSlides: true,
                    navigation: {
                        nextEl: Neighborhood.$container.find('.swiper-button-next'),
                        prevEl: Neighborhood.$container.find('.swiper-button-prev'),
                    },
                    // breakpoints: {
                    //     896: {
                    //         slidesPerView: 1.2
                    //     }
                    // },
                    on: {
                        init: function(){
                            this.update();
                            var that = this;
                            if(window.matchMedia('(max-width: 767px)').matches){
                                this.device = 'mobile';
                            }else{
                                this.device = 'desktop';
                            }

                            $(document).on('lazyloaded', function(e){
                                that.update();
                            });
                        },
                        resize: function(){
                            if(window.matchMedia('(max-width: 767px)').matches && this.device == 'desktop'){
                                this.device = 'mobile';
                                if(Common.slideMemory['mobile']){
                                    Neighborhood.$container.find('.swiper-wrapper').append(Common.slideMemory['mobile']);
                                    Common.slideMemory['mobile'] = null;
                                    
                                    Common.slideMemory['desktop'] = Neighborhood.$container.find('.swiper-slide.desktop');
                                    Neighborhood.$container.find('.swiper-slide.desktop').remove();
                                }
                            }else if(window.matchMedia('(min-width: 768px)').matches && this.device == 'mobile'){
                                this.device = 'desktop';
                                if(Common.slideMemory['desktop']){
                                    Neighborhood.$container.find('.swiper-wrapper').append(Common.slideMemory['desktop']);
                                    Common.slideMemory['desktop'] = null;

                                    Common.slideMemory['mobile'] = Neighborhood.$container.find('.swiper-slide.mobile');
                                    Neighborhood.$container.find('.swiper-slide.mobile').remove();
                                }
                            }

                            this.update();
                        }
                    }
                });
                
            });
        },
        onLeave: function() {

        },
        onLeaveCompleted: function() {
            
        }
    })
}

var Videos = {
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'videos',
        onEnter: function() {
            Videos.$container = $(this.container);
            
            
            ///////////////// init layout ///////////////
            var slider = new Swiper (Videos.$container.find('.swiper-container')[0], {
                slidesPerView: 1,
                observer: true,
                observeParents: true,
                pagination: {
                    el: Videos.$container.find('.swiper-pagination')[0],
                    clickable: true
                },
                navigation: {
                    nextEl: Videos.$container.find('.swiper-button-next')[0],
                    prevEl: Videos.$container.find('.swiper-button-prev')[0],
                },
                on: {
                    // init: function(){
                    //     var swiper = this;
                    //     Videos.$container.find('.video-options li button').on('click', function(){
                    //         var $this = $(this);
                    //         var index = $this.closest('li').index();
                    //         Videos.$container.find('.video-options li button.active').removeClass('active');
                    //         Videos.$container.find('.video-options li').eq(index).find('button').addClass('active');
                    //         swiper.slideTo(index);
                    //     });
                    // },
                    // slideChangeTransitionStart: function(){
                    //     var index = slider.activeIndex;
                    //     var name = $(slider.slides[index]).data('title');

                    //     Videos.$container.find('.video-name').text(name);

                    //     Videos.$container.find('.video-options li button.active').removeClass('active');
                    //     Videos.$container.find('.video-options li').eq(index).find('button').addClass('active');
                    // }
                    // init: function(){
                    //     var swiper = this;
                    //     Videos.$container.find('select.dropdown').on('change', function(){
                    //         var $this = $(this);
                    //         var index = $this.val();
                    //         swiper.slideTo(index);
                    //     });
                    // },
                    slideChangeTransitionStart: function(){
                        var index = slider.activeIndex;
                        var name = $(slider.slides[index]).data('title');
                        Videos.$container.find('video').each(function(){
                            this.pause();
                        });
                        Videos.$container.find('.control .title').text(name);
                    }
                }
            });

            ///////////////// events ////////////////////
            Videos.$container.find('.open-popup').on('click', function(e){
                var $content = $(e.currentTarget).find('.scrollable-popup-content');
                var popup = new ScrollablePopup();
                popup.open($content);
                Videos.initYoutube(popup.$popup);
            });

            Videos.$container.find('.nav button').on('click', function(){
                var $this = $(this);
                var index = $this.closest('li').index();
                Videos.$container.find('.nav').hide();
                Videos.$container.find('.tab-content').eq(index).show();
            });

            Videos.$container.find('.back').on('click', function(){
                Videos.$container.find('.tab-content').hide();
                Videos.$container.find('.nav').show();
            });


            Videos.$container.find('video').on('play', function (e) {
                Common.bgmEnabled = Videos.$container.find('.toggle-sound').hasClass('active');
                Common.disableBgm();
            });

            Videos.$container.find('video').on('pause', function (e) {
                if(Common.bgmEnabled) Common.enableBgm();
            });
        },
        onEnterCompleted: function() {
            Common.pageTransitionEnter();
        },
        onLeave: function() {

        },
        onLeaveCompleted: function() {
            
        }
    }),
    initYoutube: function($popup){
        YoutubeIframePlayer.container = $popup.find('.youtube-video')[0];
        YoutubeIframePlayer.videoId = $popup.find('.youtube-video').data('id');
        YoutubeIframePlayer.init();
    },
}

var Press = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'press',
        onEnter: function() {
            Press.$container = $(this.container);
            
            
        },
        onEnterCompleted: function() {
            Common.pageTransitionEnter();
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {

        }
    })
}

var Booklet = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'booklet',
        onEnter: function() {
            Booklet.$container = $(this.container);
            
            
        },
        onEnterCompleted: function() {
            Common.pageTransitionEnter();
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {

        }
    })
}

var SalesOffice = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'sales-office',
        onEnter: function() {
            SalesOffice.$container = $(this.container);
            
            SalesOffice.$container.find('.virtual-tour-popup-open').on('click', function(e){
                var $target = $(e.currentTarget);
                var id = $(this).data("id");
                var $content = $target.closest('#main').find('.scrollable-popup-content.virtual-tour');
                var popup = new ScrollablePopup();
                $content.find('iframe').attr('src', $(this).data('src'));
                popup.open($content, 'virtual-tour');

                if($(this).hasClass("disclaimer-open")){
                    setTimeout(function(){
                        var $disclaimer = $target.closest('#main').find('.scrollable-popup-content.disclaimer[data-id="'+id+'"]');
                        var popup2 = new ScrollablePopup();
                        popup2.open($disclaimer, 'vt-disclaimer');
                    }, 500);
                }
                
            });
            
            
        },
        onEnterCompleted: function() {
            Common.pageTransitionEnter();
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {

        }
    })
}

var UnitPlan = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'unit-plan',
        onEnter: function() {
            UnitPlan.$container = $(this.container);
            
            var slider = new Swiper (UnitPlan.$container.find('.swiper-container')[0], {
                slidesPerView: 1,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },on: {
                    init: function(){
                        var swiper = this;
                        UnitPlan.$container.find('select.dropdown').on('change', function(){
                            var $this = $(this);
                            var index = $this.val();
                            swiper.slideTo(index);

                            UnitPlan.$container.find('.section.index ul').removeClass('active');
                            UnitPlan.$container.find('.section.index ul').eq(index).addClass('active');
                        });
                    },
                    slideChangeTransitionStart: function(){
                        var index = slider.activeIndex;
                        var name = $(slider.slides[index]).data('title');

                        UnitPlan.$container.find('select.dropdown').val(index);
                    }
                }
            });

            UnitPlan.$container.find('.open-legend').on('click', function(e){
                $(e.currentTarget).parent().toggleClass('active');
            });
            
            
        },
        onEnterCompleted: function() {
            Common.pageTransitionEnter();
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {

        }
    })
}

var VirtualTour = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'virtual-tour',
        onEnter: function() {
            VirtualTour.$container = $(this.container);
            
            ///////////////// init layout ///////////////
            var slider = new Swiper (VirtualTour.$container.find('.swiper-container')[0], {
                slidesPerView: 1,
                observer: true,
                observeParents: true,
                pagination: {
                    el: VirtualTour.$container.find('.swiper-pagination')[0],
                    clickable: true
                },
                navigation: {
                    nextEl: VirtualTour.$container.find('.swiper-button-next')[0],
                    prevEl: VirtualTour.$container.find('.swiper-button-prev')[0],
                },
                on: {
                    init: function(){
                        var swiper = this;
                        VirtualTour.$container.find('select.dropdown').on('change', function(){
                            var $this = $(this);
                            var index = $this.val();
                            swiper.slideTo(index);
                        });
                    },
                    slideChangeTransitionStart: function(){
                        var index = slider.activeIndex;
                        var name = $(slider.slides[index]).data('title');

                        VirtualTour.$container.find('select.dropdown').val(index);
                    }
                }
            });

            ///////////////// events ////////////////////
            VirtualTour.$container.find('.virtual-tour-popup-open').on('click', function(e){
                var $target = $(e.currentTarget);
                var id = $(this).data("id");
                var $content = $target.closest('#main').find('.scrollable-popup-content.virtual-tour');
                var popup = new ScrollablePopup();
                $content.find('iframe').attr('src', $(this).data('src'));
                popup.open($content, 'virtual-tour');
                

                if($(this).hasClass("vr-open")){
                    $("html").addClass("opened-vr");
                    var $notice = VirtualTour.$container.find('.orientation-notice');
                    $("body").append($notice);
                    popup.once("close", function(){
                        $("html").removeClass("opened-vr");
                        VirtualTour.$container.append($notice);
                    });
                }

                if($(this).hasClass("disclaimer-open")){
                    setTimeout(function(){
                        var $disclaimer = $target.closest('#main').find('.scrollable-popup-content.disclaimer[data-id="'+id+'"]');
                        var popup2 = new ScrollablePopup();
                        popup2.open($disclaimer, 'vt-disclaimer');
                    }, 500);
                }
            });
            
        },
        onEnterCompleted: function() {
            Common.pageTransitionEnter();
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {

        }
    })
}

var ComingSoon = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'coming-soon',
        onEnter: function() {
            ComingSoon.$container = $(this.container);
            
            
            
            // ComingSoon.setKVHeight();
            $(window).trigger('resize');

            $(window).on('resize orientationchange', function(){
                $(window).one('resize', function(){
                    Common.video2Cover(ComingSoon.$container, 'bottom');
                });
            }).trigger('resize');
        },
        onEnterCompleted: function() {
            Common.pageTransitionEnter();
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {

        }
    })
}

var P404 = {
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'http404',
        onEnter: function() {

        },
        onEnterCompleted: function() {
            Common.pageTransitionEnter();
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {
        }
    })
}

var Polyfill = {
    init: function(){
        if (!Array.prototype.find) {
            Array.prototype.find = function(predicate) {
                if (this == null) {
                    throw new TypeError('Array.prototype.find called on null or undefined');
                }
                if (typeof predicate !== 'function') {
                    throw new TypeError('predicate must be a function');
                }
                var list = Object(this);
                var length = list.length >>> 0;
                var thisArg = arguments[1];
                var value;

                for (var i = 0; i < length; i++) {
                    value = list[i];
                    if (predicate.call(thisArg, value, i, list)) {
                        return value;
                    }
                }
                return undefined;
            };
        }
    }
}

var YoutubeIframePlayer = {
    player: null,
    container: null,
    videoId: null,
    init: function(){
        if (typeof(YT) == 'undefined' || typeof(YT.Player) == 'undefined') {
            Common.loadScript("https://www.youtube.com/iframe_api").then(function(){
                window.onYouTubeIframeAPIReady = function() {
                    YoutubeIframePlayer.initPlayer(YoutubeIframePlayer.container, YoutubeIframePlayer.videoId);
                };
            });
        }else{
            YoutubeIframePlayer.initPlayer(YoutubeIframePlayer.container, YoutubeIframePlayer.videoId);
        }
        

    },
    initPlayer: function(){
        YoutubeIframePlayer.player = new YT.Player(YoutubeIframePlayer.container, {
            height: '100%',
            width: '100%',
            videoId: YoutubeIframePlayer.videoId,
            playerVars: {
                modestbranding: 1,
                autoplay: 0,
                controls: 1,
                // mute: 1,
                showinfo: 0,
                wmode: 'transparent',
                branding: 0,
                rel: 0,
                autohide: 0,
            },
            events: {
                'onReady': YoutubeIframePlayer.onPlayerReady,
                'onStateChange': YoutubeIframePlayer.onPlayerStateChange
            }
        });
    },
    onPlayerReady:function(event){
        // event.target.playVideo();
        event.target.seekTo(0);
        event.target.stopVideo();
        Common.bgmEnabled = Common.$container.find('.toggle-sound').hasClass('active');
    },
    onPlayerStateChange: function(event){
        if (event.data === YT.PlayerState.ENDED) {
            // YoutubeIframePlayer.player.playVideo(); 

        }else if (event.data === YT.PlayerState.PLAYING) {
            // Common.bgmEnabled = Common.sound;
            Common.disableBgm();
        }else if(YT.PlayerState.PAUSED){
            if(Common.bgmEnabled) Common.enableBgm();

        }
    }
}

$(function(){
    Polyfill.init();
    
    Home.init();
    Common.init();
    Kadoorie.init();
    Vision.init();
    Architecture.init();
    Residences.init();
    View.init();
    Clubhouse.init();
    Neighborhood.init();
    Videos.init();
    Press.init();
    Booklet.init();
    SalesOffice.init();
    UnitPlan.init();
    VirtualTour.init();
    
    ComingSoon.init();
    P404.init();

    Barba.Pjax.init();
});


class ScrollablePopup {
    constructor() {
        this.top = 0;
        this.$parent = null;
        this.$content = null;
        this.markup = "<div class='scrollable-popup'><div class='overlay close'></div><div class='content'></div></div>";
        this.$popup = null;
        this.eventQueue = {};
        if(!Common.popupInstances) Common.popupInstances = [];
        Common.popupInstances.push(this);
    }

    open($element, popupClass){
        var _this = this;
        _this.$parent = $element.parent();
        _this.$content = $element;
        _this.$container = Common.popupInstances.length > 1 ? Common.popupInstances[Common.popupInstances.length - 2].$popup : $element.closest('.transition-container');
        // if(Common.popupInstances.length > 0) _this.$container = Common.popupInstances[Common.popupInstances.length - 1].$popup;
        _this.top = $(document).scrollTop();
        _this.$container.css({
            position: "fixed",
            top: -_this.top,
            // "overflow-y": "scroll"
        });
        // $(".sticky").css({
        //  position: "fixed",
        //  top: 0
        // });
        _this.$popup = $(_this.markup).clone();
        _this.$popup.addClass(popupClass);
        _this.$popup.find('.content').append($element);

        $("body").append(_this.$popup);
        $(document).scrollTop(0);

        anime.timeline({
            easing: 'easeOutCubic'
        }).add({
            targets: _this.$popup[0],
            opacity: [0,1],
            duration: 200
        }).add({
            targets: _this.$popup.find('.content')[0],
            opacity: [0,1],
            translateY: [40, 0],
            duration: 500
        });

        _this.$popup.find('.close').on('click touch',function(){
            _this.close();
        });
    }

    close(goTop){
        if($(".scrollable-popup").length){
            var _this = this;
            var top = goTop ? 0 : this.top;
            anime({
                targets: this.$popup[0],
                opacity: 0,
                easing: 'easeOutCubic',
                duration: 200,
                complete: function(){
                    _this.$parent.append(_this.$content);
                    _this.$popup.remove();
                    _this.$container.css({
                        position: "relative",
                        top: "auto",
                        // "overflow-y": ""
                    });
                    // $(".sticky").css({
                    //  position: "sticky",
                    //  top: "auto"
                    // });
                    $(document).scrollTop(top);
                    _this.destroy();
                    _this.trigger('close');
                }
            });
        }
    }

    once(event, callback){
        if(!this.eventQueue[event])
            this.eventQueue[event] = [];
        this.eventQueue[event].push(callback);
    }

    trigger(event, params){
        if(this.eventQueue[event]) {
            for(var i in this.eventQueue[event])
                this.eventQueue[event][i](params);
        }
    }

    destroy(){
        var i = Common.popupInstances.indexOf(this);
        Common.popupInstances.splice(i, 1);
        delete this;
    }
}

class Snap{
    constructor(target, sectionClass, options) {
        var _this = this;
        _this.target = target;
        _this.sectionClass = 'section' || sectionClass;
        _this.existingIndex = 0;
        _this.lastScroll = 0;
        _this.animating = false;
        _this.scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement;
        _this.offsetTop = options.offsetTop || 0;
        _this.disableBelow = options.disableBelow || 0;
        _this.enabled = false;
        _this.targetPositions = $("."+sectionClass).map(function(index, item, array){
            return $(item).offset().top;
        });
        _this.init();
        window.addEventListener('scroll', _this.animate.bind(this), false);
        window.addEventListener('resize', _this.resize.bind(this));
    }

    init(){
        var _this = this;
        if(!window.matchMedia('(max-width: '+_this.disableBelow+'px)').matches){
            if(!_this.enabled) _this.enable();
            _this.enabled = true;
            _this.targetPositions = $("."+_this.sectionClass).map(function(index, item, array){
                return $(item).offset().top;
            });
            
        }
    }

    animate(e){
        var _this = this;
        if(_this.enabled &&  !_this.animating){
            _this.scrollDirection = _this.getDirection();
            _this.nextPosition = _this.getNextPosition();
            if(this.existingIndex !== this.newIndex){
                _this.animating = true;
                anime({
                    targets: this.scrollElement,
                    scrollTop: _this.nextPosition,
                    duration: 500,
                    easing: 'easeInOutQuad',
                    complete: function(){
                        _this.existingIndex = _this.newIndex;
                        setTimeout(function(){
                            _this.lastScroll = (window.pageYOffset || document.documentElement.scrollTop)  - (document.documentElement.clientTop || 0);
                            _this.animating = false;
                        }, 50);
                    },
                });
            }
        }
    }

    getDirection(){
        this.currentScroll = (window.pageYOffset || document.documentElement.scrollTop)  - (document.documentElement.clientTop || 0);

        var direction = this.currentScroll > this.lastScroll ? 1 : -1;
        return direction;
    }

    getNextPosition(){
        if(this.existingIndex === 0){
            if(this.scrollDirection > 0){
                this.newIndex = 1;
            }
        }else if(this.existingIndex === this.targetPositions.length - 1){
            if(this.scrollDirection < 0){
                this.newIndex = this.targetPositions.length - 2;
            }
        }else{
            this.newIndex = this.existingIndex + this.scrollDirection;
        }
        return this.targetPositions[this.newIndex] - this.offsetTop;
    }

    resize(){
        var _this = this;
        if(window.matchMedia('(max-width: '+this.disableBelow+'px)').matches){
            if(_this.enabled) _this.disable();
            _this.enabled = false;
        }else{
            if(!_this.enabled) _this.enable();
            _this.enabled = true;
            _this.targetPositions = $("."+_this.sectionClass).map(function(index, item, array){
                return $(item).offset().top;
            });
        }
        
    }

    enable(){
        window.addEventListener('scroll', this.animate.bind(this), false);
    }

    disable(){
        window.removeEventListener('scroll', this.animate.bind(this));
    }

    // to(element, pos){

    // }
}
